{
  "nameInput": {
    "placeholder": "¿Cómo te llamas?"
  },
  "signIn": {
    "tagline": "Comienza con intención.",
    "signingIn": "Iniciando sesión…",
    "continueApple": "Continuar con Apple",
    "continueApple_aria": "Continuar con Apple",
    "continueGoogle": "Continuar con Google",
    "continueGoogle_aria": "Continuar con Google",
    "logo_alt": "Rhemn",
    "footer": "Al iniciar sesión, aceptas nuestros términos de servicio y la <privacyLink>Política de privacidad</privacyLink>.",
    "divider": "o"
  },
  "email": {
    "identity": {
      "label": "Dirección de correo",
      "placeholder": "you@example.com",
      "change": "Cambiar",
      "change_aria": "Cambiar dirección de correo"
    },
    "password": {
      "label": "Contraseña",
      "labelNew": "Elige una contraseña",
      "placeholder": "Contraseña",
      "placeholderNew": "Crea una contraseña",
      "show": "Mostrar contraseña",
      "hide": "Ocultar contraseña"
    },
    "actions": {
      "continue": "Continuar",
      "signIn": "Iniciar sesión",
      "createAccount": "Crear cuenta",
      "forgot": "¿Olvidaste tu contraseña?",
      "backToSignIn": "Volver a iniciar sesión",
      "iVerified": "Ya verifiqué mi correo",
      "resend": "Reenviar enlace",
      "resendIn": "Reenviar en {{time}}",
      "signInInstead": "Iniciar sesión"
    },
    "busy": {
      "checking": "Comprobando…",
      "signingIn": "Iniciando sesión…",
      "creating": "Creando tu cuenta…",
      "sending": "Enviando…"
    },
    "switch": {
      "toCreate": "¿Nuevo en Rhemn? <switchBtn>Crea una cuenta</switchBtn>",
      "toSignIn": "¿Ya tienes una cuenta? <switchBtn>Inicia sesión</switchBtn>"
    },
    "strength": {
      "tooShort": "Al menos 12 caracteres.",
      "level1": "Bien. Cuanto más larga, mejor.",
      "level2": "Contraseña segura.",
      "level3": "Contraseña muy segura."
    },
    "sent": {
      "title": "Revisa tu correo",
      "body": "Enviamos un enlace de restablecimiento a {{email}}. Caduca en una hora.",
      "resent": "Enviado de nuevo. Revisa tu correo."
    },
    "verify": {
      "title": "Confirma tu correo",
      "body": "Enviamos un enlace a {{email}}. Ábrelo para terminar de configurar tu cuenta; continuaremos automáticamente desde ahí.",
      "waiting": "Esperando a que abras el enlace…",
      "resent": "Enviado de nuevo. Revisa tu correo."
    },
    "errors": {
      "invalidEmail": "Eso no parece una dirección de correo.",
      "missingPassword": "Introduce tu contraseña.",
      "invalidCredential": "El correo o la contraseña no son correctos.",
      "emailInUse": "Ese correo ya tiene una cuenta. <signInBtn>Inicia sesión.</signInBtn>",
      "weakPassword": "Usa al menos 12 caracteres.",
      "passwordTooShort": "Usa al menos 12 caracteres.",
      "passwordCommon": "Esa contraseña es demasiado fácil de adivinar. Prueba con algo menos predecible.",
      "emailNotVerified": "Confirma tu correo antes de continuar.",
      "providerGoogle": "Este correo ya está configurado con Google. Continúa con Google abajo.",
      "providerApple": "Este correo ya está configurado con Apple. Continúa con Apple abajo.",
      "userDisabled": "Esta cuenta ha sido deshabilitada.",
      "requiresRecentLogin": "Inicia sesión de nuevo para hacer este cambio.",
      "sessionExpired": "Tu sesión ha caducado. Inicia sesión de nuevo.",
      "expiredActionCode": "Ese enlace ha caducado. Solicita uno nuevo.",
      "invalidActionCode": "Ese enlace ya no es válido. Solicita uno nuevo.",
      "tooManyRequests": "Demasiados intentos. Espera unos minutos o restablece tu contraseña.",
      "network": "Sin conexión. Comprueba tu red e inténtalo de nuevo.",
      "operationNotAllowed": "El inicio de sesión con correo no está disponible ahora mismo.",
      "generic": "Algo salió mal. Inténtalo de nuevo."
    },
    "a11y": {
      "stepEmail": "Paso 1 de 2. Introduce tu dirección de correo.",
      "stepPasswordSignIn": "Paso 2 de 2. Introduce tu contraseña para iniciar sesión.",
      "stepPasswordCreate": "Paso 2 de 2. Elige una contraseña para tu nueva cuenta.",
      "stepSent": "Enlace de restablecimiento enviado. Revisa tu correo.",
      "stepVerify": "Cuenta creada. Enlace de verificación enviado.",
      "resendReady": "Ya puedes reenviar el enlace."
    }
  }
}
